import { setupLogs } from './setupLogs.js';
import { setupRetry } from './setupRetry.js';
const configurators = [setupRetry, setupLogs];
export default configurators;
//# sourceMappingURL=configurators.js.map